import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { OrgaosComponent } from './orgaos.component';
import { OrgaoListComponent } from './orgao-list/orgao-list.component';
import { OrgaoFormComponent } from './orgao-form/orgao-form.component';
import { OrgaoNavigationService } from "./shared/orgao-navigation.service";
import { OrgaoApiService } from "./shared/orgao-api.service";
import { OrgaoService } from "./shared/orgao.service";
import { EnderecosModule } from "../enderecos/enderecos.module";
import { AreasModule } from "../areas/areas.module";
import { OrgaosRoutingModule } from "./orgaos-routing.module";
import { OrgaoTipoListComponent } from "./orgao-tipos/orgao-tipo-list/orgao-tipo-list.component";
import { OrgaoTipoFormComponent } from "./orgao-tipos/orgao-tipo-form/orgao-tipo-form.component";
import { OrgaoTipoApiService } from "./orgao-tipos/shared/orgao-tipo-api.service";
import { OrgaoTipoNavigationService } from "./orgao-tipos/shared/orgao-tipo-navigation.service";
import { OrgaoTipoService } from "./orgao-tipos/shared/orgao.service";

@NgModule({
  imports: [
    SharedModule,
    EnderecosModule,
    AreasModule,
    OrgaosRoutingModule
  ],
  providers: [
    OrgaoNavigationService,
    OrgaoApiService,
    OrgaoService,
    OrgaoTipoApiService,
    OrgaoTipoNavigationService,
    OrgaoTipoService
  ],
  declarations: [
    OrgaosComponent,
    OrgaoListComponent,
    OrgaoFormComponent,
    OrgaoTipoListComponent,
    OrgaoTipoFormComponent
  ]
})
export class OrgaosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/orgaos.module.ts
 **/